import React from "react"
import { LoadingOverlay, Modal, ModalProps, Stack } from "@mantine/core"
import classes from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/QuestionModal.module.css"

interface Props extends ModalProps {
    opened: boolean
    onClose: () => void
    children: React.ReactNode
    footer: React.ReactNode
    isLoading?: boolean
}

export const QuestionModal = ({ children, footer, ...props }: Props) => {
    return (
        <Modal
            centered
            {...props}
            classNames={{
                title: classes.modalTitle,
                content: classes.modalContent,
                body: classes.modalBody,
                header: classes.modalHeader,
                ...props.classNames,
            }}
        >
            {props.isLoading && <LoadingOverlay visible />}
            <Stack spacing="md">
                <div className={classes.paddingContainer}>{children}</div>
                <div className={classes.footer}>
                    <div className={classes.paddingContainer}>{footer}</div>
                </div>
            </Stack>
        </Modal>
    )
}
